import { render } from "./GamesView.vue?vue&type=template&id=4a9c7d0b&scoped=true&ts=true"
import script from "./GamesView.vue?vue&type=script&lang=ts"
export * from "./GamesView.vue?vue&type=script&lang=ts"

import "./GamesView.vue?vue&type=style&index=0&id=4a9c7d0b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a9c7d0b"]])

export default __exports__